 
import CONQUER from "../../CONQUER";
import LOG, { log } from "../../../UTIL/LOG";
import GameInstance from "../GameInstance";
import TimerInstance from "../../../UTIL/Instances/TimerInstance";
import STRING from "../../../UTIL/STRING";
import MATH from "../../../UTIL/MATH";
import ARRAY from "../../../UTIL/ARRAY";
 
class MissionInstance
{
    private conquer             : CONQUER;
    private gameInstance        : GameInstance;

    public key                  : string;
    public vars                 : any;
    public category             : string;
    public text                 : string;
    public amount               : number = 0;
    public varName              : string;
    public persistent           : boolean;
    public time                 : number;
    public value                : any;
    public currency             : string;
    public name                 : string;
    private isCollection        : boolean;
    public isComplete           : boolean = false;
    public listener             : any;

    public timer                : any | TimerInstance;
    public isEnabled            : boolean = true;
    public isStarted            : boolean = false;
 
    constructor( gameInstance:GameInstance, vars:any )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;

        this.vars           = vars;

        this.key            = vars.key;
        this.category       = vars.category;
        this.text           = vars.text;
        this.amount         = vars.amount;
        this.varName        = vars.varName;
        this.time           = vars.time;
        this.persistent     = vars.persistent;
        this.isCollection   = vars.isCollection;
        this.currency       = vars.currency || "Coin";
        this.name           = vars.name;

        let self            = this;
 
        if( this.time )     this.timer = new TimerInstance({ id:"MissionTime", onUpdate:()=>self.onTimeUpdate(), onTimeUp:()=>self.onTimeUp(), Signal:gameInstance.Signal });
 
        
    }

    public start()
    {
        if( !this.isEnabled || this.isStarted ) return;

        this.reset();

        this.isStarted = true; 

        if( this.time ) this.timer.start( { seconds:this.time });
 
        if( this.varName === "PlayerScoreIncrease"  )
        {
            this.value  = this.gameInstance.Data.data.PlayerScore || 0;
            this.amount += this.value;
        }

        if( this.category === "BeatRival" )
        {
            this.amount = ( this.gameInstance.Data.data.RivalScore || 0 ) + 1;
        }
 
        if( this.varName === "Survive" )
        {
            this.amount = this.time;
            this.varName = "MissionTime:onSecond";
        }
 
        this.text = STRING.replace( this.vars.text, 
        {
            amount      : this.amount,
            time        : this.time,
            name        : this.name,
            currency    : this.currency || "Coins"
        });
    }

    public onValue( name:string, value?:any )
    {
        if( !this.isEnabled ) return;
        if( this.isComplete ) return;

        if( name !== this.varName ) return;

        this.setValue( value || 1 );
    }
 
    public setValue( value?:any )
    {
        if( !this.isEnabled ) return;
        if( this.isComplete ) return;

        value = value || 1;
 
        if( this.isCollection )
        {
            ARRAY.pushUnique( this.value, value );

        }else{
 
            if( this.varName === "MissionTime:onSecond" )
            {
                this.value = this.time - value;
            }else{
                this.value += value;
            }

            value = MATH.clamp( value, this.amount );
        }
 
        if( this.persistent )
        {
            this.gameInstance.Data.set( this.key, this.value );
        }else{
            this.gameInstance.Data.display( this.key, this.value );
        }

        this.onUpdate();

        let val : number = this.isCollection ? this.value.length : this.value;

        if( val < this.amount ) return;

        this.isComplete = true;

        this.stop();

        this.gameInstance.Quest.increase();

        this.onComplete();
    }

 
    public onUpdate()
    {
        //fire( "MISSION:onUpdate" );
    }

    public onComplete()
    {
        //fire( "MISSION:onComplete" );
    }

    public pause()
    {
        if( this.timer ) this.timer.pause();
    }

    public resume()
    {
        if( this.timer ) this.timer.resume();
    }
 
    public remove()
    {
        this.isStarted = false; 
        this.gameInstance.Missions.remove( this.key );
        this.stopTime();
        this.disable();
    }
    
    public disable()
    {
        this.isStarted = false; 
        this.isEnabled = false;
    }

    private _onTimeUpdate()
    {
        this.setValue( 1 );
        this.onTimeUpdate();
    }

    public onTimeUpdate()
    {

    }

    private _onTimeUp()
    {
        this.onTimeUp();
    }

    public onTimeUp()
    {

    }

    public reset()
    {
        this.stop();

        this.value          = this.persistent ? this.gameInstance.Data.data[ this.key ] || 0 : 0;
        if( this.isCollection && !this.value ) this.value = [];
    }

    public stop()
    {
        this.isStarted = false; 
        this.stopTime();
    }

    public stopTime()
    {
        if( this.timer ) this.timer.stop();
    }
 
}

export default MissionInstance;